import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { CommissionRulesManagementUpdate } from '../modal';


export default function reducer(state: CommissionRulesManagementUpdate = new CommissionRulesManagementUpdate(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.COMMISSION_RULES_UPDATE_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.COMMISSION_RULES_UPDATE_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.COMMISSION_RULES_UPDATE_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
